import React from 'react';
import './App.css';
import Main from './components/Main.jsx';
import { DirectionProvider } from './contexts/DirectionContext';
import ErrorBoundary from './components/ErrorBoundary';


function App() {


  return (
    <ErrorBoundary>
      <DirectionProvider>
        <div className="App" style={{ height: '100%' }}>
            <Main />
        </div>
      </DirectionProvider>
    </ErrorBoundary>
  );
}

export default App;
